import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const StyledFoorPlan = styled.svg`
  ${({ animated }) =>
    animated &&
    css`
      path {
        transform-origin: center;
      }

      path:nth-child(1) {
        transform: scale(0.8);
        opacity: 0;
        animation: pulse 3s infinite;
      }

      path:nth-child(2) {
        transform: scale(0.8);
        opacity: 0;
        animation: pulse 3s 800ms infinite;
      }
    `}

  @keyframes pulse {
    0% {
      opacity: 0;
      transform: scale(0.8);
    }

    50% {
      opacity: 1;
      transform: scale(1);
    }

    100% {
      opacity: 0;
      transform: scale(1);
    }
  }
`;

const FloorPlanOpen = ({ className, animated = false }) => (
  <StyledFoorPlan
    animated={animated}
    className={className}
    role="presentation"
    width="64"
    height="69"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fillRule="evenodd">
      <path
        d="M46.554 38.887a1.06 1.06 0 00.54 1.407 1.077 1.077 0 001.407-.543c4.117-9.165.026-19.863-9.136-23.894-9.163-4.03-19.927.133-24.045 9.299-2.446 5.448-2.064 11.723 1.022 16.792a1.066 1.066 0 001.536.296 1.07 1.07 0 00.358-1.466c-4.601-7.515-2.19-17.373 5.387-22.019 7.576-4.645 17.446-2.32 22.047 5.196a15.93 15.93 0 01.884 14.932"
        strokeWidth=".75"
      />
      <path
        d="M8.135 52.763c.358.422.994.472 1.42.112l.005-.004c.423-.363.473-.996.112-1.415a27.984 27.984 0 01-1.525-1.94C-1.23 36.491 1.823 18.27 14.965 8.819c13.143-9.452 31.4-6.554 40.775 6.472 7.625 10.59 7.192 25.002-1.056 35.244-.35.436-.28 1.069.154 1.415.436.343 1.072.27 1.42-.167 10.843-13.47 8.75-33.064-4.679-43.765C38.154-2.684 18.477-.439 7.635 13.031-1.178 23.98-1.64 39.382 6.509 50.7c.514.715 1.032 1.43 1.626 2.063"
        strokeWidth=".75"
      />
      <path d="M36.317 38.72a5.819 5.819 0 01-8.201-.648 5.813 5.813 0 01.663-8.197c2.448-2.085 6.12-1.795 8.2.647a5.812 5.812 0 01-.662 8.198" />
      <path d="M30 48h3v21h-3z" />
    </g>
  </StyledFoorPlan>
);

FloorPlanOpen.propTypes = {
  className: PropTypes.string,
  animated: PropTypes.bool
};

export default FloorPlanOpen;
